var React = require('react');

function PropertyWw (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"property-ww"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1-2"},[React.createElement("polygon",{"points":"34.02 22.24 28.75 0 18.82 0 13.56 22.27 9.97 0 0 0 7.56 39.79 17.86 39.79 23.79 14.74 25.8 23.17 43.09 23.16 47.54 0 37.62 0 34.02 22.24","key":0}),React.createElement("polygon",{"points":"38.1 32.69 36.38 24.46 32.54 24.46 30.83 32.71 29.67 24.46 26.15 24.46 28.7 39.79 32.36 39.79 34.47 29.66 35.18 33.07 35.63 35.25 36.58 39.79 40.23 39.79 40.97 35.34 41.33 33.18 42.77 24.46 39.26 24.46 38.1 32.69","key":1})]))]);
}

PropertyWw.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 47.54 39.79"};

module.exports = PropertyWw;

PropertyWw.default = PropertyWw;
